// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qeBSxDqKMTOjwUI63fwK{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K{width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2em}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K .npOP7WNi9byL3X9o9c7m{flex:2 0 auto;justify-content:center;align-items:center;display:flex}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K .AX9wvQ70pF6cijt7T2Z0{flex:0 0 auto}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K h4{font-size:1.5rem;margin-bottom:1rem;color:#6e32f0;text-transform:uppercase}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K ul{list-style-type:disc;padding-left:1.5rem;margin-bottom:2rem}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K ul li{margin-bottom:.5rem}.qeBSxDqKMTOjwUI63fwK .qIPaP9Uvg_GOd63T714K ul li span{font-weight:600;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"FurtherMaterials": `qeBSxDqKMTOjwUI63fwK`,
	"rightComponent": `qIPaP9Uvg_GOd63T714K`,
	"listsWrapper": `npOP7WNi9byL3X9o9c7m`,
	"infoBox": `AX9wvQ70pF6cijt7T2Z0`
};
export default ___CSS_LOADER_EXPORT___;
